import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Video, Users, Shield, Zap } from 'lucide-react';
import "../styles/LandingPage.css"; // Note the new CSS file name

export default function LandingPage() {

  const navigate = useNavigate(); // Renamed 'router' to 'navigate' for clarity

  return (
    <div className='landingPageContainer'>
      <nav className='navbar'>
        <div className='navHeader'>
          <Video className="navIcon" />
          <h2>Connectify</h2>
        </div>
        <div className='navList'>
          <p onClick={() => navigate("/aaaa4578")} className='navLink'>Join as guest</p>
          <p onClick={() => navigate("/auth")} className='navLink'>Register</p>
          <div onClick={() => navigate("/auth")} role='button' className='loginButton'>
            <p>Login</p>
          </div>
        </div>
      </nav>

      <div className="landingMainContainer">
        <div className="landingContent">
          <h1><span className="highlight">Connect</span> with your loved Ones</h1>
          <p className="subtitle">Cover a distance by Connectify</p>
          <div role='button' className="getStartedButton" onClick={() => navigate("/auth")}>
            Get Started
          </div>

          <div className="featureGrid">
            <div className="featureItem">
              <div className="featureIconBackground">
                <Users className="featureIcon" />
              </div>
              <p>Group Calls</p>
            </div>
            <div className="featureItem">
              <div className="featureIconBackground">
                <Shield className="featureIcon" />
              </div>
              <p>Secure</p>
            </div>
            <div className="featureItem">
              <div className="featureIconBackground">
                <Zap className="featureIcon" />
              </div>
              <p>Fast</p>
            </div>
          </div>
        </div>

        <div className="landingVisual">
          <div className="visualBackgroundBlur"></div>
          <div className="visualCard">
            <div className="visualPlaceholder">
              <Video className="placeholderIcon" />
            </div>
            <div className="visualMockup">
                <div className="mockupItem mockupOrange">
                    <div className="mockupAvatar"></div>
                    <div className="mockupTextContainer">
                        <div className="mockupTextLine mockupTextLine1"></div>
                        <div className="mockupTextLine mockupTextLine2"></div>
                    </div>
                </div>
                <div className="mockupItem mockupBlue">
                    <div className="mockupAvatar mockupAvatarBlue"></div>
                    <div className="mockupTextContainer">
                        <div className="mockupTextLine mockupTextLine3"></div>
                        <div className="mockupTextLine mockupTextLine4"></div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}